// ======================================================================
// File Name       : LivePerformanceListForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead, { setSortState } from '../../components/TableHead';
import * as contentConstant from '../../constants/ContentConstant';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { liveStartFromToFormat } from '../../utils/UsageSettingLiveUtils';
import ReduxFormPaging from '../ReduxFormPaging';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';

class LivePerformanceListForm extends React.Component {
  render() {
    const {
      livePerformanceListObj,
      handleSortState,
      recordNum,
      getStartEndData,
      handleMouseEnter,
      handleMouseLeave,
    } = this.props;

    const thead = [
      { title: 'ライブ名', sortBy: 1 , width: '25%' },
      { title: 'ライブ開催者名', sortBy: 5 },
      { title: '開始日時', sortBy: 2 },
      { title: '終了日時', sortBy: 3 },
      { title: '参加者数', sortBy: null, width: '10%' },
      { title: '招待者数', sortBy: null, width: '10%' },
      { title: '操作', sortBy: null, width: 100 },
    ];

    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="liveSortType"
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>
            {livePerformanceListObj && livePerformanceListObj.allSecernIds && livePerformanceListObj.allSecernIds.map((liveKey, index) => {
              const bySecernId = livePerformanceListObj.bySecernId ? livePerformanceListObj.bySecernId : {};
              const {
                  liveName,
                  liveStartFrom,
                  liveStartTo,
                  invitedUserCount,
                  attendedUserCount,
                  liveSecernId,
                  organizerUserName,
              } = bySecernId[liveKey];
              const link = Path.USER_HISTORY_LIVE_PERFORMANCE_DETAIL.replace(':id', liveSecernId);
              return (
                <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
                  <td>
                    {liveName}
                  </td>
                  <td>
                    {organizerUserName}
                  </td>
                  <td>
                    {liveStartFromToFormat(liveStartFrom)}
                  </td>
                  <td>
                    {liveStartFromToFormat(liveStartTo)}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {attendedUserCount}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {invitedUserCount}
                  </td>
                  <td className="text-center">
                    <CustomLink
                      className="margin-right-7 link-detail"
                      to={link}
                      text="詳細を見る"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Form.Group className="text-center">
          <Col sm={12}>
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
           />
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default LivePerformanceListForm;
